<template>
  <main>
    <GridWrapper>
      <SectionSet isFirst>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <BreadCrumbs
            class="col-span-6 col-start-1 w-[182px] text-lg uppercase leading-[1.2] tracking-[0.08em] text-ng70 laptop:col-span-10 laptop:col-start-2 laptop:text-xl laptop:leading-[1.7]"
          />
          <h1
            class="col-span-6 col-start-1 text-lg laptop:col-span-8 laptop:col-start-2 laptop:text-[32px]"
            v-html="newLinesToBreaks(forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_title || '')"
          />
          <div
            class="col-span-6 col-start-1 mt-12 italic laptop:col-start-6 laptop:mt-14 [&>*+*]:mt-6"
            v-html="marked.parse(forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_description || '')"
          ></div>
          <div
            class="col-span-6 col-start-1 mt-12 flex flex-col space-y-6 laptop:col-span-10 laptop:col-start-2 laptop:mt-14 laptop:flex-row laptop:space-y-0 laptop:space-x-6"
          >
            <LinkCard
              :bg="'bg-pink'"
              :title="forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_private_label?.title"
              :subtitle="forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_private_label?.subtitle"
              :img="
                forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_private_label?.image?.data?.attributes
                  ?.url
              "
              :link="localePath({ name: 'for-business-private-label' })"
              :arrow="'#B06C4C'"
            />
            <LinkCard
              :bg="'bg-blue'"
              :title="forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_food_service?.title"
              :subtitle="forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_food_service?.subtitle"
              :img="
                forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_food_service?.image?.data?.attributes
                  ?.url
              "
              :link="localePath({ name: 'for-business-food-service' })"
              :arrow="'#647E8D'"
            />
            <LinkCard
              :bg="'bg-green'"
              :title="forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_brands?.title"
              :subtitle="forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_brands?.subtitle"
              :img="
                forBusinessPageData?.forBusinessPage?.data?.attributes?.hero_tile_brands?.image?.data?.attributes?.url
              "
              :link="localePath({ name: 'brands' })"
              :arrow="'#B0B358'"
            />
          </div>
          <NextBtn
            class="col-span-6 col-start-1 mx-auto mt-[39px] laptop:col-span-4 laptop:col-start-5 laptop:mt-[41px]"
            :text="$t('Contact Form')"
            :to="localePath({ name: 'contact' })"
          />
        </div>
      </SectionSet>
    </GridWrapper>
    <GridsOutterGrid>
      <SectionSet isLast class="col-span-3 col-start-1 laptop:col-start-2 laptop:col-end-3">
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 col-start-1 laptop:col-span-10 laptop:col-start-2">
            <SliderBrands
              :title="$t('our-newest-products')"
              :buttonText="$t('see-more')"
              :products="forBusinessPageData?.newProducts?.data"
              :link="localePath({ name: 'products' })"
            />
          </div>
        </div>
      </SectionSet>
    </GridsOutterGrid>
  </main>
</template>
<script setup lang="ts">
import { marked } from "marked";
import { newLinesToBreaks } from "~/js/text";

const { locale, finalizePendingLocaleChange } = useI18n();

const localePath = useLocalePath();

await finalizePendingLocaleChange();

const { data: forBusinessPageData } = await useAsyncGql({
  operation: "ForBusinessPage",
  variables: { locale: locale.value },
  options: {
    lazy: false,
  },
});

const pageTitle = ref<string | null>(null);

watch(
  forBusinessPageData,
  (newVal) => {
    if (newVal) {
      if (newVal.forBusinessPage?.data?.attributes?.seo?.metaTitle) {
        pageTitle.value = newVal.forBusinessPage?.data?.attributes?.seo?.metaTitle;
      }
      useHead({
        title: () => pageTitle.value,
      });
      useServerSeoMeta({
        title: () => `${newVal.forBusinessPage?.data?.attributes?.seo?.metaTitle}`,
        ogTitle: () => `${newVal.forBusinessPage?.data?.attributes?.seo?.metaTitle}`,
        description: () => `${newVal.forBusinessPage?.data?.attributes?.seo?.metaDescription}`,
        ogDescription: () => `${newVal.forBusinessPage?.data?.attributes?.seo?.metaDescription}`,
        ogImage: () => `${newVal.forBusinessPage?.data?.attributes?.seo?.metaImage?.data?.attributes?.url}`,
      });
    }
  },
  { immediate: true },
);
</script>
<style lang="scss" scoped></style>
